module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('label', [_vm._v("Show\n            "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "name": "example1_length",
      "aria-controls": "example1"
    },
    on: {
      "change": _vm.showSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("New user")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "aria-label": "Creation date",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Creation Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Name",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Firstname",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Firstname")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Username",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Username",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.users.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user._id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(user.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-close clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Remove User"
      },
      on: {
        "click": function($event) {
          return _vm.confirmRemoveUser(user._id)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), (_vm.users.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "example1_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("Showing \n            " + _vm._s(_vm.total - _vm.users.length + 1 > _vm.page * _vm.size + 1 ? _vm.page * _vm.size + 1 : _vm.total - _vm.users.length + 1) + "\n            to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to delte this user ?",
      "title": "Delete Confirmation",
      "id": "ConfirmModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.remove()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7140c0c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/UsersList.vue
// module id = 447
// module chunks = 1